import React from 'react';

import CouponSave from '../coupon/couponSave/CouponSave';

import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';

const doctorLabel = doctor =>
    `${doctor?.name?.firstName || ''} ${doctor?.name?.lastName || ''}`.trim();

const FullDoctorCouponModal = ({ open, onClose, doctor, onSaved }) => {
    const handleSaved = coupon => {
        onSaved?.(coupon);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{ sx: { maxHeight: '94vh' } }}
        >
            <DialogTitle>
                Registrar cupón para {doctorLabel(doctor) || 'médico'}
                <Typography variant="body2" color="text.secondary">
                    El ejecutivo de la sesión y el médico quedarán vinculados automáticamente.
                </Typography>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 0 }}>
                {doctor &&
                    <CouponSave
                        key={doctor._id}
                        embedded
                        initialDoctor={doctor}
                        onSaved={handleSaved}
                        onCancel={onClose}
                    />
                }
            </DialogContent>
        </Dialog>
    );
};

export default FullDoctorCouponModal;
